module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Bucket-b2af2ab90b852029fb7686f7a7851f44.svg";